module.exports = __webpack_public_path__ + "images/contact-banner.f94b70f.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/contact-banner.png
// module id = 635
// module chunks = 0